// extracted by mini-css-extract-plugin
module.exports = {"footer":"BaseDialog_footer__3wgRe"};